/* eslint-disable */

import React, { FC, ForwardedRef, useRef, useState } from "react";

import { Box } from "@mui/material";
import Button from "components/Button";
import { REACT_APP_API_URL_REPORT } from "constants/index";
import HTMLFlipBook from "react-pageflip";
import { useNavigate, useParams } from "react-router-dom";
// import { useGetReportDistributionFileQuery } from 'generated/graphql'
interface Props {
  data: Array<{ id: string; url: string; page: number }> | null | undefined;
  expiredAt: any;
  allowDownload: boolean;
}
interface PageProps {
  element?: any;
}
const Page: FC<PageProps> = React.forwardRef<HTMLDivElement, PageProps>(
  (props: PageProps, ref: ForwardedRef<HTMLDivElement>) => {
    return (
      <Box
        sx={{
          boxShadow: "0 25px 50px -12px rgb(0 0 0 / 0.25)",
        }}
        ref={ref}
      >
        <Box
          sx={{
            width: "100%",
          }}
          component="img"
          src={props?.element?.url}
          alt={props?.element?.page}
        />
        {/* <div className="flex justify-center">{props.element.page}</div> */}
      </Box>
    );
  }
);

export const ReportDistributionDetailForm = (props: Props) => {
  const [page, setPage] = useState<number>(0);
  const book = useRef(null);
  const { id } = useParams();
  const [allowRefetch, setAllowRefetch] = useState(false);
  const { data, allowDownload } = props;
  const navigate = useNavigate();

  const isMD = window.innerWidth <= 768;
  const isXL = window.innerWidth > 768 && window.innerWidth < 1280;
  const is2XL = window.innerWidth >= 1280;
  const nextButtonClick = () => {
    // @ts-ignore
    book.current.pageFlip().flipNext();
  };

  const prevButtonClick = () => {
    // @ts-ignore
    book.current.pageFlip().flipPrev();
  };

  const getCurrentPage = (page: number, total: number): string => {
    if (total === 0) {
      return `0`;
    }
    if (page === total - 1) {
      return `${page + 1}`;
    }
    return `${page + 1}-${page + 2}`;
  };

  const getWidthBook = () => {
    if (is2XL) {
      return 597;
    }
    if (isXL) {
      return 597;
    }
    if (isMD) {
      return window.innerWidth - 20;
    }
  };
  const getHeightBook = () => {
    if (is2XL) {
      return 843;
    }
    if (isXL) {
      return 843;
    }
    if (isMD) {
      return (window.innerWidth - 20) / 0.7068214804;
    }
  };
  return new Date(props?.expiredAt) > new Date() ? (
    <Box>
      <Box
        display="flex"
        justifyContent="end"
        marginTop="12px"
        marginRight="12px"
        height="32px"
      >
        {allowDownload ? (
          <a
            href={`${REACT_APP_API_URL_REPORT}/report-distribution/download?distributionId=${id}`}
          >
            <Button
              // loading={allowRefetch}
              onClick={() => {
                setAllowRefetch(true);
              }}
            >
              Download
            </Button>
          </a>
        ) : (
          <div className="h-8" />
        )}
      </Box>

      {/* 
    //@ts-ignore */}
      <HTMLFlipBook
        className="flip-book"
        width={getWidthBook() as number}
        height={getHeightBook() as number}
        ref={book}
        onFlip={(e: any) => {
          setPage(e.data);
        }}
        size="fixed"
        // minWidth={window.innerWidth - 20}
        // maxWidth={597}
        // minHeight={(window.innerWidth - 20) / 0.7068214804}
        // maxHeight={843}
        // showCover={isMobile}
        startPage={0}
        // mobileScrollSupport={true}
      >
        {data?.map((e: any, index: number) => {
          return <Page element={e} key={index} />;
        })}
        {data && data?.length % 2 > 0 && is2XL ? <div /> : <></>}
      </HTMLFlipBook>
      <Box display="flex" justifyContent="center" marginTop="28px">
        <div>
          <Button
            variant="outlined"
            sx={{
              marginRight: "14px",
            }}
            onClick={prevButtonClick}
          >
            Previous page
          </Button>

          {isXL || isMD ? (
            <span>{`[${page + 1} of ${data?.length}]`}</span>
          ) : (
            <span>{`[${getCurrentPage(page, data?.length ?? 0)} of ${
              data?.length
            }]`}</span>
          )}

          <Button
            variant="outlined"
            sx={{
              marginLeft: "14px",
            }}
            onClick={nextButtonClick}
          >
            Next page
          </Button>
        </div>
      </Box>
    </Box>
  ) : (
    <>page not found</>
  );
};
